/**
 * External Dependencies
 */
import 'jquery';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';

SwiperCore.use([Pagination]);

$(document).ready(() => {
  /* Initialize logo Swiper on frontpage */
  const swiper = new SwiperCore('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 100,
      disableOnInteraction: false,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  const swiperFull = new SwiperCore('.swiper-container-full', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  swiper.init();
  swiperFull.init();

  /**
   * jQuery AJAX filter. Combines both forms on page.
   * Could probably be refactored into a single function 
   */
  jQuery(function ($) {
    var sidebarFilter = $('#filter');
    var homeFilter = $('#searchfilter');

    $('#filter').on('change', function () {
      sidebarFilter = $('#filter');
      $.ajax({
        url: sidebarFilter.attr('action'),
        data: sidebarFilter.serialize() + '&' + homeFilter.serialize(), // form data
        type: sidebarFilter.attr('method'), // POST
        beforeSend: function (xhr) {
          // filter.find('button').text('Processing...'); // changing the button label
        },
        success: function (data) {
          // filter.find('button').text('Apply filter'); // changing the button label back
          $('#response').html(data); // insert data
        },
      });
    });

    $('#searchfilter').on('submit', function (e) {
      e.preventDefault();
      homeFilter = $('#searchfilter');
      $.ajax({
        url: sidebarFilter.attr('action'),
        data: sidebarFilter.serialize() + '&' + homeFilter.serialize(), // form data combined from both filters
        type: sidebarFilter.attr('method'), // POST
        beforeSend: function (xhr) {
          // filter.find('button').text('Processing...'); // changing the button label
        },
        success: function (data) {
          // filter.find('button').text('Apply filter'); // changing the button label back
          $('#response').html(data); // insert data
        },
      });
    });
    return false;
  });

  /**
   * Mega menu slider only for vacature! activated by 
   * nav-mega-menu class in 
   */
  $('#menu-item-6').on('mouseenter', function () {
    if ($(window).width() < 1024) return;
    $('.nav-mega-menu').slideDown('slow');
    $('.sub-menu').css('opacity', '0');
  });
  $('.nav-mega-menu').on('mouseleave', function () {
    if ($(window).width() < 1024) return;
    $(this).slideUp('fast');
    $('.sub-menu').css('opacity', '100');
  });

  /**
   * Mobile menu 
   */
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.nav-primary').toggleClass('mobile-active');
    $('body').toggleClass('mobile-nav-active overflow-filter');
  });

  $('#filter-button').on('click', function () {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    $('.aside-filter').toggleClass('mobile-active');
    $('body').toggleClass('overflow-filter');
  });

  $('#sidebar-filter-close').on('click', function () {
    $('.aside-filter').toggleClass('mobile-active');
    $('body').toggleClass('overflow-filter');
  });

  /**
   * Function to display vacature CTA on page bottom left
   * Refactor from:
   * https://bitbucket.org/booomdevelopment/adaptics/src/ec97018b0ce9007b194eaedffd85567e6a8828d5/resources/assets/scripts/routes/common.js?at=master
   * To be honest I don't really get it -OAP
   */
  const mq = window.matchMedia('(max-width: 1220px)');
  mq.addListener(WidthChange);
  WidthChange(mq);

  function WidthChange(mq) {
    if (mq.matches) {
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (!document.body.classList.contains('mobile-nav-active')) {
          if (prevScrollpos > currentScrollPos) {
            //  document.getElementsByClassName('c__main-nav')[0].style.top = '0';
          } else {
            //  document.getElementsByClassName('c__main-nav')[0].style.top = '-125px';
          }
          prevScrollpos = currentScrollPos;
        }
      };
    } else {
      // do nothing
    }
  }

  const mq2 = window.matchMedia('(min-width: 671px)');
  mq2.addListener(WidthChange);
  WidthChange2(mq2);
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  function WidthChange2(mq2) {
    if (mq2.matches) {
      $(window).on('resize scroll', function () {
        // Added exit return clause to prevent errors on pages with no header-vacature
        if(!$('#header-vacature').length) return;
        if (!$('#header-vacature').isInViewport()) {
          $('#cta-soliciteer').removeClass('hidden');
        } else {
          $('#cta-soliciteer').addClass('hidden');
          
        }
      });
    }
  }

  /**
   * Modal Popup trigger sollicitatie
   */
  $(document).on('click', '#btn-solliciteer-1, #btn-solliciteer-2, #btn-solliciteer-3', () => {
    $('#lidWordenModal').fadeIn();
  })

  $('#closeLidModal').on('click', () => {
    $('#lidWordenModal').fadeOut();
  })
});
